export default __webpack_public_path__ + "static/media/affiliate-image.2fcb4b9b.jpg";